export enum CallQueueStatus {
  PENDING = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  TERMINATED = 4,
  PAUSED = 5
}
